import { render, staticRenderFns } from "./SubscribeButton.vue?vue&type=template&id=18dea679&scoped=true&"
import script from "./SubscribeButton.vue?vue&type=script&lang=js&"
export * from "./SubscribeButton.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeButton.vue?vue&type=style&index=0&id=18dea679&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dea679",
  null
  
)

export default component.exports